module.exports = __webpack_public_path__ + "img/risk-related-policy.7b735163.png";